"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginScene = exports.LoginSceneComponent = void 0;
const formik_1 = require("formik");
const react_1 = __importStar(require("react"));
const react_helmet_1 = require("react-helmet");
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const AuthLayout_1 = require("../../components/AuthLayout/AuthLayout");
const config_1 = require("../../config");
const requests_1 = require("../../requests");
const routes_1 = require("../../routes");
const LoginForm_1 = require("../../scene-forms/LoginForm");
const CONTEXT = 'LoginScene';
exports.LoginSceneComponent = (props) => {
    const { onError, onSubmit, titleBlock, loginFieldName = 'email', showForgotPasswordLink = true, } = props;
    const [redirect, setRedirect] = react_1.useState('');
    const [message, setMessage] = react_1.useState('');
    const { t } = react_i18next_1.useTranslation('LoginScene');
    const submit = (body) => {
        setMessage('');
        if (onSubmit)
            return onSubmit(body);
        return requests_1.loginRequest(body)
            .then((r) => config_1.saveAccessInformation(r.data.id, r.data.userId))
            .then(() => setRedirect(routes_1.routes.HOME))
            .catch((e) => {
            if (onError)
                return onError(e);
            return setMessage(config_1.getErrorMessage(e));
        });
    };
    const getLinks = () => {
        const links = [];
        if (showForgotPasswordLink) {
            links.push({
                to: routes_1.routes.FORGOT,
                id: `${CONTEXT}-forgot-link`,
                text: t('forgotPassword'),
            });
        }
        if (config_1.getReleoxOptions().showRegisterLink) {
            links.push({
                to: routes_1.routes.REGISTER,
                id: `${CONTEXT}-register-link`,
                text: t('register'),
            });
        }
        return links;
    };
    const initFormValues = { [loginFieldName]: '', password: '' };
    if (redirect)
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: redirect });
    return (react_1.default.createElement(AuthLayout_1.AuthLayout, { titleBlock: titleBlock, context: CONTEXT, links: getLinks() },
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("title", null, `${t('title')}`)),
        react_1.default.createElement(formik_1.Formik, { initialValues: initFormValues, onSubmit: submit }, () => react_1.default.createElement(LoginForm_1.LoginForm, { loginFieldName: loginFieldName, context: CONTEXT, message: message }))));
};
exports.LoginScene = exports.LoginSceneComponent;
//# sourceMappingURL=LoginScene.js.map